<template>
  <NovaRequisicaoMaterialComponent
    :category="3"
    :title="'Requisição Material NR10'"
  />
</template>

<script>
import NovaRequisicaoMaterialComponent from "../components/NovaRequisicaoMaterialComponent.vue";
export default {
  components: {
    NovaRequisicaoMaterialComponent,
  },
};
</script>

<style></style>
